// extracted by mini-css-extract-plugin
export var banner = "header-module--banner--3e057";
export var cart_on = "header-module--cart_on--344a8";
export var cart_qty = "header-module--cart_qty--8a930";
export var curr = "header-module--curr--6fe1d";
export var deskhead = "header-module--deskhead--cd2a8";
export var features = "header-module--features--43a75";
export var gend_link = "header-module--gend_link--8ddd4";
export var group_wrap = "header-module--group_wrap--87cda";
export var hamberger = "header-module--hamberger--15b4e";
export var hcontent = "header-module--hcontent--48a70";
export var hlink = "header-module--hlink--ed3b7";
export var hlogo_svg = "header-module--hlogo_svg--569c0";
export var hpanels = "header-module--hpanels--32299";
export var icon = "header-module--icon--b4533";
export var iconHamberger = "header-module--icon-hamberger--2007b";
export var journ_link = "header-module--journ_link--4be4d";
export var journ_place = "header-module--journ_place--6684b";
export var journ_prev = "header-module--journ_prev--2ca9a";
export var journal_link = "header-module--journal_link--f137d";
export var logged_in = "header-module--logged_in--0a29a";
export var logo_el = "header-module--logo_el--6ed9d";
export var logo_link = "header-module--logo_link--29d6f";
export var main_btn = "header-module--main_btn--55374";
export var main_btns = "header-module--main_btns--37240";
export var main_cont = "header-module--main_cont--02e6b";
export var main_side = "header-module--main_side--b037a";
export var mobhead = "header-module--mobhead--33447";
export var mobhead_gend = "header-module--mobhead_gend--69890";
export var mobhead_right = "header-module--mobhead_right--f7498";
export var mobhead_sec = "header-module--mobhead_sec--88cbe";
export var nd_head = "header-module--nd_head--9a5d0";
export var nicon = "header-module--nicon--75d41";
export var on = "header-module--on--bd736";
export var open = "header-module--open--33b5f";
export var panel = "header-module--panel--f2660";
export var promo_img = "header-module--promo_img--6e299";
export var promo_item = "header-module--promo_item--b65b7";
export var promos = "header-module--promos--db513";
export var sub_group = "header-module--sub_group--95ebd";
export var sub_head = "header-module--sub_head--157be";
export var subtitle = "header-module--subtitle--ec34b";
export var testhidemob = "header-module--testhidemob--4c17a";
export var testmobhead = "header-module--testmobhead--16038";
export var testshow = "header-module--testshow--a9d86";
export var title = "header-module--title--7d3e4";
export var wardbtn = "header-module--wardbtn--78b71";